import React from "react";
import isEmpty from 'lodash/isEmpty';
import "./header.css";
import smallLogo from "images/finpay-small-logo.svg";
import fullLogo from "images/finpay-logo.png";
import { Link } from "react-router-dom";
import { ButtonToolbar, DropdownButton, Glyphicon } from "react-bootstrap";
import { connect } from "react-redux";
import SignOutButton from '../../auth/components/sign-out-button';
import NotificationMessage from "shared/components/notification-message";
import MediaQuery from "react-responsive";

function Header(props) {
  const {user = {}} = props;

  const dropdown = (
    <ButtonToolbar>
      <DropdownButton
        title={user.first_name + " " + user.last_name}
        id="dropdown-size-medium"
        pullRight={true}
      >
        <li>
          <Link to={"/settings"}>
            <Glyphicon glyph="cog" /> Account & Settings
          </Link>
        </li>
        <li className="divider" />
        <li className="logout">
          <SignOutButton next={props.afterLogout}>Sign out</SignOutButton>
        </li>
      </DropdownButton>
    </ButtonToolbar>
  );

  const notificationModal =
    props.visibility && props.visibility.NotificationMessage ? (
      <NotificationMessage
        selectBankAccount={props.selectBankAccount}
        closeAchVerification={props.closeAchVerification}
        handleVerifyAccount={props.handleVerifyAccount}
        bank_accounts={props.NotificationMessage.bank_accounts}
      />
    ) : null;

  return (
    <div>
      <header>
        <div className="container">
          <div className="logo">
            <MediaQuery minWidth={992}>
              <a href="/">
                <img src={fullLogo} alt="Logo" className="full-logo" />
              </a>
            </MediaQuery>
            <MediaQuery minWidth={320} maxWidth={991}>
              <a href="/">
                <img src={smallLogo} alt="Logo" className="small-logo" />
              </a>
            </MediaQuery>
          </div>
          {(props.signedIn && !props.staticPage && !isEmpty(user)) ? dropdown : null}
        </div>
      </header>

      {props.signedIn && !props.staticPage ? notificationModal : null}
    </div>
  );
}

export default connect(({ auth: {isSignedIn} }) => ({
  signedIn: isSignedIn
}))(Header);



// WEBPACK FOOTER //
// ./src/shared/components/header.js